export default "__VITE_ASSET__lzDzogqY__"